/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useMemo } from 'react';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import {
  clearOnboardingSubmission,
  getOnboardingAll,
  getOnboardingForms,
} from '../../data/store/onboarding/onboardingActions';
import StorageService from '../../services/StorageService';
import SessionService from '../../services/SessionService';
import { calculateTotalAUM } from '../../helpers/calculateTotalAUM';
import { numberWithSpacesInter } from '../../helpers/formatInteger';

import ButtonAdd from '../../components/ButtonAdd/ButtonAdd';
import CustomSearchInput from '../../components/CustomSearchInput/CustomSearchInput';
import { Button, Col, Layout, Row } from 'antd';

import { ReactComponent as Filter } from '../../assets/filter-icon.svg';

import ModalFilterClients from './ModalFilterClients';
import AccountsTable from './AccountsTable';

import './style.scss';

const { Header } = Layout;

const Dashboard = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation('');

  const {
    advisor: { first_name },
  } = useSelector((state) => state.userReducer);
  const accounts = useSelector(
    (state) => state.accountReducer?.accounts?.list || [],
  );
  const { isLoading } = useSelector((state) => state.accountReducer);
  const { onboardingList } = useSelector((state) => state.onboardingReducer);
  const token = StorageService.getJWTToken() || SessionService.getJWTToken();

  const [openFilter, setOpenFilter] = useState(null);
  const [totalAUM, setTotalAUM] = useState(0);
  const [filter, setFilter] = useState(null);
  const [search, setSearch] = useState(null);

  const debounceTimer = React.useRef(null);

  useEffect(() => {
    dispatch(getOnboardingForms());
    setTimeout(() => {
      dispatch(getOnboardingAll());
    }, 1000);
    return () => {
      dispatch(clearOnboardingSubmission());
      if (debounceTimer.current) {
        clearTimeout(debounceTimer.current);
      }
    };
  }, []);

  useEffect(() => {
    const accountIds = accounts.map((account) => account.id);
    calculateTotalAUM(accountIds, token).then(setTotalAUM);
  }, [accounts]);

  const getStatus = (accountId) => {
    const onboardings = onboardingList?.filter(
      (item) => item.account_id === accountId,
    );
    if (!onboardings?.length) return 'NONE';
    if (
      onboardings.every(
        (e) => e.status === 'COMPLETED' || e.status === 'CANCELED',
      )
    )
      return 'DONE';
    return 'PENDING';
  };
  // const none =  []
  const pending = [
    'AVAILABLE',
    'EDITING',
    'SUBMITTED',
    'PENDING',
    'CREATED',
    'SENT',
    'ERROR',
  ];
  // const done =  [CANCELED, COMPLETED]

  const filteredAccounts = useMemo(() => {
    const statusFilter = filter?.status
      ? Object.keys(filter.status).filter(
          (key) => filter.status[key] && key !== 'ALL',
        )
      : [];
    console.log('🚀 ~ Dashboard ~ statusFilter:', statusFilter);
    const typeFilter = filter?.type
      ? Object.keys(filter.type).filter(
          (key) => filter.type[key] && key !== 'ALL',
        )
      : [];

    let filtered = accounts;
    if (statusFilter.length > 0) {
      filtered = filtered.filter((account) => {
        const accountStatus = getStatus(account.id);
        return statusFilter.includes(accountStatus);
      });
    }
    if (typeFilter.length > 0) {
      filtered = filtered.filter((account) => {
        return typeFilter.includes(
          account.type === 'private' ? 'PERSON' : 'ORGANIZATION',
        );
      });
    }

    if (!search) return filtered;
    const result = filtered.filter((account) => {
      const name = account?.company_name || account?.name || '';
      return (
        name.toLowerCase().includes(search.toLowerCase()) ||
        account?.owner?.email?.toLowerCase()?.includes(search.toLowerCase())
      );
    });
    return result;
  }, [accounts, search, filter]);

  const handleCreateUser = () => {
    history.push('/users/invite-advisor');
  };

  const handleCreateAccount = () => {
    history.push('/accounts/new-account');
  };

  const handleSearch = (e) => {
    const { value } = e.target;
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }
    debounceTimer.current = setTimeout(() => {
      setSearch(value);
    }, 1000);
  };

  const handeleFilter = () => {
    setOpenFilter(true);
  };

  const countPandingOnboarding = useMemo(() => {
    const count = onboardingList?.reduce((acc, item) => {
      const isAccountPresent = accounts.some((account) => account.id === item.account_id);
      if (!isAccountPresent) return acc;
      if (pending.includes(item.status)) {
        acc++;
      }
      return acc;
    }, 0) ?? 0;
    return count;
  }, [onboardingList]);

  return (
    <div className="instrument-wrapper instrument-block-wrap">
      <div className="top-btn-wrapper">
        <ButtonAdd
          title="ADD_USER"
          height="32px"
          onClick={() => handleCreateUser()}
        />
        <ButtonAdd
          title="ADD_INDIVIDUAL_CORPORATION"
          height="32px"
          onClick={() => handleCreateAccount()}
        />
      </div>
      <Header className="headerStyle contrast dashboard-header">
        <Row className="overview-tabs-wrapper">
          <Col className="tabs-tab-wrapper" span={18}>
            <Button type="text" className="overview-btn header-btn">
              {t('DASHBOARD')}
            </Button>
          </Col>
        </Row>
        <Row className="instrument-header-row" justify={'space-between'}>
          <Col>
            <h2 className="dashboard-subheader-title">
              {t('WELCOME_BACK')} {first_name}
            </h2>
          </Col>
          <Col className="dashboard-search-wrapper">
            <CustomSearchInput
              className="account-select-search onboarding"
              placeholder={t('SEARCH_CLIENT')}
              onChange={handleSearch}
            />
            <Button
              className="filter-btn"
              type="default"
              onClick={handeleFilter}
              icon={<Filter />}
              iconPosition="end"
            >
              {t('FILTER')}
            </Button>
          </Col>
        </Row>
      </Header>
      <div style={{ width: '100%', marginTop: '154px' }}>
        <div className="dashboard-card-wrapper">
          <div className="dashboard-card">
            <h3 className="card-title">{t('YOUR_CLIENT')}</h3>
            <p className="card-description">{t('NO_OF_CLIENT')}</p>
            <p className="card-count">{accounts.length}</p>
          </div>
          <div className="dashboard-card">
            <h3 className="card-title">{t('AUM_DEVELOPMENT')}</h3>
            <p className="card-description">{t('NO_OF_CLIENTS_AUM')}</p>
            <p className="card-count">
              {numberWithSpacesInter(totalAUM, 0) + ' kr'}
            </p>
          </div>
          <div className="dashboard-card">
            <h3 className="card-title">{t('OPEN_ADVICE')}</h3>
            <p className="card-description">{t('NUMBER_OF_COMPLETED')}</p>
            <p className="card-count">{countPandingOnboarding}</p>
          </div>
        </div>
        <AccountsTable
          accounts={filteredAccounts.sort((a, b) =>
            a.name.localeCompare(b.name),
          )}
          onboardingList={onboardingList}
          isLoading={isLoading}
        />
      </div>
      {openFilter && (
        <ModalFilterClients
          filter={filter}
          openFilter={openFilter}
          handleCloseFilter={() => setOpenFilter(false)}
          setFilter={setFilter}
        />
      )}
    </div>
  );
};

export default Dashboard;
